/**
 * @file src/pages/refunds/logic/stats.js
 * @description Pure math for Refunds page summary stats.
 *
 * No React, no state, no side effects. Easy to unit test.
 *
 * Each function takes an array of records and returns a number.
 * `parseFloat(... || 0)` defends against missing/null amount fields
 * coming back from the API.
 */

/**
 * Sum the `amount` field across a list of records (refunds or credit notes).
 * @param {Array<{ amount?: number | string }>} list
 * @returns {number}
 */
export const sumAmount = (list) =>
  list.reduce((total, item) => total + (parseFloat(item.amount) || 0), 0);
